/* eslint-disable array-callback-return */
import dayjs from 'dayjs'
import { Link, useParams } from 'react-router-dom'

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/modules/shared/components/ui/card'

import type { Release } from '../types/release.type'
type Props = {
  release: Release
}

export function ReleaseCard({ release }: Props) {
  const { id } = useParams()

  const hasEmptyCompanyCode = release.releaseNotes?.find((note) => {
    if (!note.companyCode) return note
  })

  const hasCompanyCode = release.releaseNotes?.find((note) => {
    if (note.companyCode === id) return note
  })

  if (!hasCompanyCode && !hasEmptyCompanyCode) return null

  return (
    <div className="w-full flex justify-center mb-5">
      <Card className="w-full p-5">
        <CardHeader>
          <CardTitle className="text-primary">Versão {release.code}</CardTitle>
          <label className="text-sm">
            {dayjs(release.releaseDate).format('DD/MM/YYYY')}
          </label>
        </CardHeader>
        <CardContent>
          {release.releaseNotes?.find((note) => {
            if (
              note.noteType === 0 &&
              (note.companyCode === id || !note.companyCode)
            )
              return note
          }) && <h2 className="font-bold mb-1 text-lg">Novos Recursos</h2>}

          <ul className="list-disc gap-2">
            {release.releaseNotes?.map(
              (note) =>
                note.noteType === 0 &&
                (note.companyCode === id || !note.companyCode) && (
                  <li key={note.id} className="mb-2">
                    <div className={'flex gap-3'}>
                      <h3 className="font-semibold">{note.topic}</h3>
                    </div>
                    <div
                      className="text-sm"
                      dangerouslySetInnerHTML={{
                        __html: note.description,
                      }}
                    />
                    {note.link && (
                      <Link
                        className="text-red-600 hover:underline text-sm"
                        to={`/documentacao/${note.link}`}
                      >
                        {' '}
                        Saiba Mais{' '}
                      </Link>
                    )}
                  </li>
                ),
            )}
          </ul>
          <br />

          <ul className="list-disc">
            {release.releaseNotes?.find((note) => {
              if (
                note.noteType === 1 &&
                (note.companyCode === id || !note.companyCode)
              )
                return note
            }) && <h2 className="font-bold mb-1 text-lg">Correções</h2>}

            {release.releaseNotes?.map(
              (note) =>
                note.noteType === 1 &&
                (note.companyCode === id || !note.companyCode) && (
                  <li key={note.id} className="mb-2">
                    <div className={'flex gap-0 item flex-col'}>
                      <h3 className="font-semibold">{note.topic}</h3>
                    </div>
                    <div
                      className="text-sm"
                      dangerouslySetInnerHTML={{
                        __html: note.description,
                      }}
                    />
                    {note.link && (
                      <Link
                        className="text-red-600 hover:underline text-nowrap text-sm"
                        to={`/documentacao/${note.link}`}
                      >
                        {' '}
                        Saiba Mais{' '}
                      </Link>
                    )}
                  </li>
                ),
            )}
          </ul>
          <br />
          <ul className="list-disc">
            {release.releaseNotes?.find((note) => {
              if (
                note.noteType === 2 &&
                (note.companyCode === id || !note.companyCode)
              )
                return note
            }) && <h2 className="font-bold  mb-1 text-lg">Melhorias</h2>}

            {release.releaseNotes?.map(
              (note) =>
                note.noteType === 2 &&
                (note.companyCode === id || !note.companyCode) && (
                  <li key={note.id} className="mb-2">
                    <div className={'flex gap-3'}>
                      <h3 className="font-semibold">{note.topic}</h3>
                    </div>
                    <div
                      className="text-sm"
                      dangerouslySetInnerHTML={{
                        __html: note.description,
                      }}
                    />
                    {note.link && (
                      <Link
                        className="text-red-600 hover:underline text-nowrap text-sm"
                        to={`/documentacao/${note.link}`}
                      >
                        {' '}
                        Saiba Mais{' '}
                      </Link>
                    )}
                  </li>
                ),
            )}
          </ul>
        </CardContent>
      </Card>
    </div>
  )
}
